export default "__VITE_ASSET__1ltddiWU__"